import styled from '@emotion/styled';
import { BLACK, WHITE } from '../../../styles/color';
import { TABLET_SIZE } from '../../../styles/common';

interface FlowDotItemProps {
  isActive: boolean;
}

interface FlowDotLineProps {
  isActive: boolean;
  widthClass: 'width97' | 'width118' | 'width140' | '';
}

export const StepContentLayout = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70px;
  background-color: ${BLACK};
  ${TABLET_SIZE} {
    height: 65px;
  }
`;

export const StepContentInner = styled.div`
  margin-inline: auto;
`;

export const FlowDot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 21px;
`;

export const FlowDotItem = styled.div<FlowDotItemProps>`
  position: relative;
  display: block;
  flex: none;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: ${WHITE};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
`;

export const FlowDotWord = styled.div`
  position: absolute;
  top: 20px;
  left: 50%;
  color: ${WHITE};
  white-space: nowrap;
  letter-spacing: 0.05em;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  transform: translateX(-50%);
  ${TABLET_SIZE} {
    font-size: 11px;
  }
`;

export const FlowDotLine = styled.hr<FlowDotLineProps>`
  display: block;
  height: 3px;
  border: none;
  border-color: ${WHITE};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  width: ${({ widthClass }) => {
    switch (widthClass) {
      case 'width97':
        return '97px';
      case 'width118':
        return '118px';
      case 'width140':
        return '140px';
      default:
        return 'auto';
    }
  }};
  ${TABLET_SIZE} {
    width: ${({ widthClass }) => {
      switch (widthClass) {
        case 'width97':
          return '55px';
        case 'width118':
          return '75px';
        case 'width140':
          return '90px';
        default:
          return 'auto';
      }
    }};
  }
`;
